import BaseInternalApiService from './BaseInternalApiService';

class OrderApiService extends BaseInternalApiService {
  getOrders(params) {
    return this.getAxiosInstance().get('/orders', { params });
  }

  getOrderById(orderId) {
    return this.getAxiosInstance().get(`/orders/${orderId}`);
  }

  updateOrderStatus(orderId, data) {
    // data: { status, note }
    return this.getAxiosInstance().put(`/orders/${orderId}/status`, data);
  }
}

export default new OrderApiService(); 